import { useNavigate } from 'react-router-dom';
import { useAccessGateState } from '@breath-lab/state';
import { upgradePath } from '../../routes';

export function useAccessGate() {
  const navigate = useNavigate();
  const { ctx, isBreathworkAccessible, isJourneyAccessible } = useAccessGateState();

  return {
    ctx,
    isBreathworkAccessible,
    isJourneyAccessible,
    requireAccess: (
      hasAccess: boolean,
      onGranted: () => void,
      onDenied?: () => void,
    ): void => {
      if (hasAccess) {
        onGranted();
      } else if (onDenied) {
        onDenied();
      } else {
        navigate(upgradePath(), { state: { returnTo: window.location.pathname } });
      }
    },
  };
}
